<template>
  <div class="loading-icon">
    <svg
      version="1.1"
      class="loading-icon__svg iconic-clock"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100px"
      height="100px"
      viewBox="0 0 384 384"
      xml:space="preserve"
    >
      <g>
        <circle
          class="iconic-clock-frame"
          cx="192"
          cy="192"
          r="172"
          fill="#ffffff"
          stroke="#000000"
          stroke-width="35"
        >
          <title>Loading...</title>
        </circle>
        <line
          class="iconic-clock-hour-hand"
          id="iconic-anim-clock-hour-hand"
          fill="none"
          stroke="#000000"
          stroke-width="30"
          stroke-miterlimit="10"
          x1="192"
          y1="192"
          x2="192"
          y2="87.5"
        ></line>
        <line
          class="iconic-clock-minute-hand"
          id="iconic-anim-clock-minute-hand"
          fill="none"
          stroke="#000000"
          stroke-width="30"
          stroke-miterlimit="10"
          x1="192"
          y1="192"
          x2="192"
          y2="54"
        ></line>
        <circle class="iconic-clock-axis" cx="192" cy="192" r="15"></circle>
      </g>
      <defs>
        <animateTransform
          type="rotate"
          fill="remove"
          restart="always"
          calcMode="linear"
          accumulate="none"
          additive="sum"
          xlink:href="#iconic-anim-clock-hour-hand"
          repeatCount="indefinite"
          dur="12s"
          to="360 192 192"
          from="0 192 192"
          attributeName="transform"
          attributeType="xml"
        ></animateTransform>

        <animateTransform
          type="rotate"
          fill="remove"
          restart="always"
          calcMode="linear"
          accumulate="none"
          additive="sum"
          xlink:href="#iconic-anim-clock-minute-hand"
          repeatCount="indefinite"
          dur="4s"
          to="360 192 192"
          from="0 192 192"
          attributeName="transform"
          attributeType="xml"
        ></animateTransform>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: "loading",
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.loading-icon {
  display: flex;
  justify-content: center;
  margin: 1rem;
  opacity: 1;
}

.loading-icon__svg {
  width: 75px;
  height: 75px;
}

.loading-icon.fade-leave-active {
  transition: opacity 0.5s ease-in;

  .loading-icon__svg {
    transition: width 0.5s ease-in;
  }
}
.loading-icon.fade-leave-to {
  opacity: 0;

  .loading-icon__svg {
    width: 50px;
  }
}

.iconic-clock-frame,
.iconic-clock-hour-hand,
.iconic-clock-minute-hand,
.iconic-clock-frame {
  stroke: $primary;
}
.iconic-clock-axis {
  fill: $primary;
}
</style>
